import React from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/figtree/latin-400.css";
import "@fontsource/figtree/latin-600.css";
import "@fontsource/figtree/latin-700.css";
import "@fontsource/figtree/latin-800.css";

// Buyers open their tracking link on all kinds of phones, often on slow data, so that page
// loads on its own without the rest of the app. Everyone else gets the shop app.
const root = createRoot(document.getElementById("root")!);
const track = location.pathname.match(/^\/t\/([0-9a-fA-F]{24})\/?$/);
const failed = () => root.render(<p style={{ padding: 24, fontFamily: "sans-serif" }}>This page didn't load. Check your connection and refresh.</p>);

if (track) {
  void import("./pages/Track").then(({ default: Track }) => root.render(<React.StrictMode><Track token={track[1].toLowerCase()} /></React.StrictMode>), failed);
} else {
  void import("./shell").then(({ default: App }) => root.render(<React.StrictMode><App /></React.StrictMode>), failed);
}
